import { render } from "./MainTemplate.vue?vue&type=template&id=683d3454&scoped=true"
import script from "./MainTemplate.vue?vue&type=script&lang=js"
export * from "./MainTemplate.vue?vue&type=script&lang=js"

import "./dashboard.scss?vue&type=style&index=0&id=683d3454&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-683d3454"]])

export default __exports__